import { Anchor, CopyButton, Group, Stack, Text, Tooltip } from "@mantine/core";
import { IconBrandWhatsapp, IconCopy } from "@tabler/icons-react";
import { useState } from "react";
import {
  CONTACT_CHANNEL_PHONE,
  CONTACT_CHANNEL_WHATSAPP,
  WHATSAPP_CANDIDATE_LABEL,
} from "../../constants/matching";
import {
  CALL_NUMBER_COPIED,
  COPY_EMAIL_LABEL,
} from "../explore/constants";
import { PhoneDialLinks } from "../explore/CallDialQr";
import { LogContactModal } from "./LogContactModal";

function whatsappHref(phone: string): string | null {
  const digits = phone.replace(/\D/g, "").slice(-10);
  if (digits.length !== 10) return null;
  return `https://wa.me/91${digits}`;
}

export function ContactActions({
  phone,
  candidateId,
  jobId,
  phoneLabel,
  email,
  enableLog = true,
}: {
  phone: string;
  candidateId: string;
  jobId?: string | null;
  phoneLabel?: string;
  email?: string | null;
  enableLog?: boolean;
}) {
  const [logOpen, setLogOpen] = useState(false);
  const [channel, setChannel] = useState<string | null>(null);
  const wa = whatsappHref(phone);
  const emailValue = email?.trim() ?? "";

  function promptLog(nextChannel: string) {
    if (!enableLog) return;
    setChannel(nextChannel);
    setLogOpen(true);
  }

  const phoneActions = (
    <Group gap="var(--axio-unit-6)" wrap="nowrap">
      <span
        onClick={() => promptLog(CONTACT_CHANNEL_PHONE)}
        onKeyDown={() => undefined}
        role="presentation"
      >
        <PhoneDialLinks phone={phone} />
      </span>
      {wa ? (
        <Tooltip label={WHATSAPP_CANDIDATE_LABEL}>
          <Anchor
            href={wa}
            target="_blank"
            rel="noopener noreferrer"
            c="green"
            display="inline-flex"
            aria-label={WHATSAPP_CANDIDATE_LABEL}
            onClick={() => promptLog(CONTACT_CHANNEL_WHATSAPP)}
          >
            <IconBrandWhatsapp size="var(--axio-unit-14)" />
          </Anchor>
        </Tooltip>
      ) : null}
    </Group>
  );

  return (
    <>
      <Stack gap="var(--axio-unit-0)" align="flex-start">
        {phoneLabel ? (
          <Group gap="var(--axio-unit-6)" wrap="nowrap">
            <Text size="xs" c="dimmed" className="tabular">
              {phoneLabel}
            </Text>
            {phoneActions}
          </Group>
        ) : (
          phoneActions
        )}
        {emailValue ? (
          <Group gap="var(--axio-unit-6)" wrap="nowrap">
            <Text size="xs" c="dimmed">
              {emailValue}
            </Text>
            <CopyButton value={emailValue}>
              {({ copied, copy }) => (
                <Tooltip label={copied ? CALL_NUMBER_COPIED : COPY_EMAIL_LABEL}>
                  <Anchor
                    component="button"
                    type="button"
                    size="xs"
                    c="dimmed"
                    aria-label={COPY_EMAIL_LABEL}
                    display="inline-flex"
                    onClick={copy}
                  >
                    <IconCopy size="var(--axio-unit-14)" />
                  </Anchor>
                </Tooltip>
              )}
            </CopyButton>
          </Group>
        ) : null}
      </Stack>
      {logOpen ? (
        <LogContactModal
          opened={logOpen}
          onClose={() => setLogOpen(false)}
          candidateId={candidateId}
          jobId={jobId}
          defaultChannel={channel}
        />
      ) : null}
    </>
  );
}
